import { useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { ErrorMessage } from "./ErrorMessage";
import { IconClose } from "./icons";
import { Modal } from "./Modal";

export function FeedbackModal({ onClose }) {
  const location = useLocation();
  const [type, setType]       = useState("bug");
  const [subject, setSubject] = useState("");
  const [body, setBody]       = useState("");
  const [busy, setBusy]       = useState(false);
  const [done, setDone]       = useState(false);
  const [error, setError]     = useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.submitFeedback({
        type,
        subject,
        body,
        metadata: { route: location.pathname },
      });
      setDone(true);
    } catch (err) {
      if (err.status === 429) {
        setError("You've sent several reports recently — please try again in an hour.");
      } else {
        setError("Failed to send. Please try again.");
      }
      setBusy(false);
    }
  }

  return (
    <Modal variant="feedback" onClose={onClose} label="Send feedback">
      {/* Header matches .panel-head style */}
      <div className="panel-head feedback-modal-head">
        <span className="panel-title">Send feedback</span>
        <button className="icon-btn feedback-close" onClick={onClose} aria-label="Close">
          <IconClose />
        </button>
      </div>

      <div className="feedback-modal-body">
        {done ? (
          <div className="feedback-done">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36" className="feedback-done-icon">
              <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <p className="feedback-done-msg">Thanks — we got it.</p>
            <button className="btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="feedback-type-row">
              {[
                { value: "bug",        label: "Bug report",  emoji: "🐛" },
                { value: "suggestion", label: "Suggestion",  emoji: "💡" },
              ].map(({ value, label, emoji }) => (
                <button
                  key={value}
                  type="button"
                  className={"feedback-type-btn" + (type === value ? " active" : "")}
                  onClick={() => setType(value)}
                >
                  <span>{emoji}</span>
                  <span>{label}</span>
                </button>
              ))}
            </div>

            <div className="field field--profile u-mb-12">
              <label className="profile-label">Subject</label>
              <input
                className="input"
                required
                maxLength={100}
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder={type === "bug" ? "What went wrong?" : "What could be better?"}
                autoFocus
              />
            </div>

            <div className="field field--profile u-mb-12">
              <label className="profile-label">Details</label>
              <textarea
                className="input input--auto-height"
                required
                maxLength={2000}
                rows={5}
                value={body}
                onChange={(e) => setBody(e.target.value)}
                placeholder="Describe the issue or idea…"
              />
            </div>

            <ErrorMessage message={error} className="u-mb-10" />

            <div className="btn-row btn-row--end">
              <button type="button" className="btn ghost" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn" disabled={busy}>
                {busy ? "Sending…" : "Send"}
              </button>
            </div>
          </form>
        )}
      </div>
    </Modal>
  );
}
